import request from './request';

export function getPetition(id){
  return request('get', `/apiv2/petitions/${id}`);
}

export function closePetition(id, data){
  return request('post', `/apiv2/petitions/${id}/close`, data);
}

export async function addSignatureToPetition(id, data){
  return request('post', `/apiv2/petitions/${id}/signers`, data);
}

export function addPetition(petition){
  return request('post', `/apiv2/petitions/add`, petition);
}

export function relatedPetition(id){
  return request('get', `/apiv2/petitions/${id}/related`, {});
}

export function getMyPetition(params){
  return request('get', '/apiv2/petitions/created', params);
}